<template>
  <div class="modal is-visible">
    <div class="modal-wrapper">
      <div class="modal-header" v-if="title != undefined && title.length > 0">
        <h2 class="modal-heading">{{ title }}</h2>
      </div>
      <div class="modal-body">
        <div class="modal-content">
          <div class="msg-text" :class="align">
            <p v-html="text"></p>
          </div>
        </div>
      </div>

      <div class="modal-footer" :class="getBtnClass">
        <button
          class="btn modal-toggle"
          v-for="(item, idx) in buttons"
          v-bind:key="idx"
          :class="item.class"
          @click="clickButton(idx, item.handler)"
        >
          {{ item.title }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title", "text", "align", "buttons"],
  computed: {
    getBtnClass() {
      let classVal = null;
      if (this.buttons.length > 1) {
        classVal = "col-" + this.buttons.length;
      }
      return classVal;
    }
  },
  methods: {
    clickButton(index, handler) {
      handler(index, this);
    }
  }
};
</script>
